export default __webpack_public_path__ + "static/media/credentiality.68947ef1.svg";